import { ProviderContext } from "notistack";
import Dispatcher from "./Dispatcher";

 const snackbarDispatcher =
  // We don't want global stateful objects on the server side
  typeof window !== "undefined" ? new Dispatcher<Parameters<ProviderContext["enqueueSnackbar"]>>() : undefined;

 export { snackbarDispatcher }